import { createContext } from "react";
import type { NostrEvent } from "@nostrify/nostrify";

export interface GMContextType {
  /** All GM notes from contacts in the last 24 hours */
  gmNotes: NostrEvent[];
  /** User's own GM replies in the last 24 hours */
  userReplies: NostrEvent[];
  /** Whether the initial scan is in progress */
  isScanning: boolean;
  /** Progress of the current scan */
  scanProgress: { scanned: number; found: number };
  /** Whether contacts have been loaded */
  contactsLoaded: boolean;
  /** Number of contacts */
  contactCount: number;
  /** The current user's own root GM note for today, if they've posted one */
  myGMNote: NostrEvent | null;
  /** Whether the initial check for today's GM note is still in progress */
  isLoadingMyGMNote: boolean;
  /** Direct replies to the user's own GM note today */
  myGMReplies: NostrEvent[];
  /** Manually set the user's own GM note (e.g. right after publishing) */
  setMyGMNote: (note: NostrEvent) => void;
}

export const GMContext = createContext<GMContextType | undefined>(undefined);
